import {
	getContextMenuItems,
	getHideableLayoutFunc
} from '../shared-configs/hideable-layout-helper.js';

export const hideableLayoutContextMenuItems = getContextMenuItems();
export const hideableLayoutFunc = getHideableLayoutFunc([
	'dataLabelsHideableLayout',
	'layoutHideableLayout',
	'minorValuesHideableLayout',
	'nodesHideableLayout',
	'templateHideableLayout',
	'totalHideableLayout'
]);
